import { render, staticRenderFns } from "./product-broken-detail-dialog.vue?vue&type=template&id=6a0bf4de&scoped=true"
import script from "./product-broken-detail-dialog.ts?vue&type=script&lang=ts&external"
export * from "./product-broken-detail-dialog.ts?vue&type=script&lang=ts&external"
import style0 from "./product-broken-detail-dialog.scoped.scss?vue&type=style&index=0&id=6a0bf4de&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0bf4de",
  null
  
)

export default component.exports